import { ShopDefinition } from '../types/shop.types';
import { ItemType } from '../types/inventory.types';

/**
 * Shop catalogue. Price calibration parked Phase 11.
 *
 * The `apothecary` (label "Vendeur") is a **rolling** shop: at each run cycle
 * it redraws a random stock of 4 consumables (from its `offers` pool) + 2
 * grimoires (from `GRIMOIRE_POOL`). Each rolled item is buyable once per cycle.
 * See `ShopService` + docs/hub.md.
 */
export const SHOP_REGISTRY: Record<string, ShopDefinition> = {
  apothecary: {
    id: 'apothecary',
    label: 'Vendeur',
    rolling: {
      consumableCount: 4,
      grimoireCount: 2,
      grimoirePrice: 250,
      featuredTrinket: { minorId: 'blank-charm', priceGold: 350 },
    },
    offers: [
      { itemId: 'pill-life', priceGold: 50 },
      { itemId: 'pill-spirit', priceGold: 35 },
      { itemId: 'antidote', priceGold: 25 },
      { itemId: 'elixir-sharp', priceGold: 120 },
      { itemId: 'elixir-solid', priceGold: 120 },
      { itemId: 'elixir-swift', priceGold: 120 },
      { itemId: 'thunder-in-a-box', priceGold: 80 },
      { itemId: 'reviver-seed', priceGold: 500 },
    ],
    buysTypes: [ItemType.CONSUMABLE],
  },
  // B8 — Wandering Merchant: temporary merchant NPC (global location).
  // The items `pill-life`, `pill-spirit`, `antidote`, `elixir-*`,
  // `thunder-in-a-box`, `escape-orb` are introduced by B8 plan T4;
  // reference by id is supported since `itemId` is a non-strict string.
  'wandering-merchant': {
    id: 'wandering-merchant',
    label: 'Marchand-Ambulant',
    offers: [
      { itemId: 'pill-life', priceGold: 60 },
      { itemId: 'pill-spirit', priceGold: 40 },
      { itemId: 'antidote', priceGold: 30 },
      { itemId: 'elixir-sharp', priceGold: 100 },
      { itemId: 'elixir-solid', priceGold: 100 },
      { itemId: 'elixir-swift', priceGold: 100 },
      { itemId: 'thunder-in-a-box', priceGold: 80 },
      { itemId: 'escape-orb', priceGold: 500 },
    ],
    buysTypes: [ItemType.CONSUMABLE, ItemType.MATERIAL],
  },
};
